import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { isAdmin } from '../../store/action/auth';

const Layout = ({type,children,location}) => {
  if (isAdmin()) {
    return (
      <div className="dashboard-content">
        <Header />
        <main role="main" className="col-md-12 px-4">
          <section className="mt-6">
            {children}
          </section>
        </main>
      </div>
    )
  }
  return (
    <div className="dashboard-content">
      <Header />
      <br/>
      <div className="container-fluid" id="wrapper">
        <div className="row">
          <Sidebar location={location}/>
          <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
            <section className="mt-6 bg-lighter">
              {children}
            </section>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Layout;
